import React from "react";
import { LinkInfo } from "../../models/shared/LinkInfo";
import { isNullOrWhiteSpace } from "../../shared/string";
import { PressReleaseSignupForm } from "../Forms/PressReleaseSignupForm";
import { getHelpCardColorTheme, HelpCardColorTheme, HelpCardType } from "./HelpCard";
import HelpCardContainer, {
    Props as ContainerProps
} from "./HelpCardContainer";

export type SanityHelpCardPressReleaseSignup = {
    _type: HelpCardType.PressReleaseSignup;
    title: string;
    preamble: string;
    policyLink: LinkInfo;
};

export interface HelpCardPressReleaseSignupProps extends ContainerProps, SanityHelpCardPressReleaseSignup {

}

const HelpCardPressReleaseSignup = (props: HelpCardPressReleaseSignupProps) => {
    const {
        title,
        preamble,
        ...containerProps
    } = props;

    const {
        textColor,
        hrColor
    } = getHelpCardColorTheme(HelpCardColorTheme.Variant5);
    
    return (
        <HelpCardContainer 
            {...containerProps} 
            colorTheme={HelpCardColorTheme.Variant5} 
            roundedClassName="rounded-lg"
        >
            {!isNullOrWhiteSpace(title) && (
                <>
                    <h3 className={`mb-4 font-bold ${textColor}`}>{title}</h3>
                    <hr className={`h-divider-thick w-16 ${hrColor} mb-4 lg:mb-6`} />
                </>
            )}
            {!isNullOrWhiteSpace(preamble) &&
                <p className={`mb-10 ${textColor}`}>{preamble}</p>
            }
            <PressReleaseSignupForm policyLink={props.policyLink} />
        </HelpCardContainer>
    );
};

export default HelpCardPressReleaseSignup;